<template>
  <div class="live-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <!-- 表格 -->
        <div class="btn" @click="handleLiveModal('add')">+ 新增视频号</div>
        <!-- <span class="tip">轮播图最多上传5张</span> -->
        <el-table
          :data="liveList"
          class="order-table table no-border-table"
          ref="orderTable"
          :header-cell-style="{
            border: 'none',
            color: '#333',
            background: '#f6f6f6',
            borderBottom: '1px solid #E8E8E8',
            height: '54px',
          }"
          :row-style="{
            height: '54px',
          }"
        >
          <el-table-column
            prop="name"
            align="center"
            label="视频号名称"
          ></el-table-column>
          <el-table-column
            prop="channelsId"
            align="center"
            label="视频号ID"
          ></el-table-column>
          <el-table-column
            prop="created"
            align="center"
            label="设为跳转目标"
            width="180"
          >
            <div
              slot-scope="scope"
              style="display: flex;justify-content: center;"
              @click="updateLiveStatus(scope.row)"
            >
              <i
                v-if="scope.row.status === 1"
                class="iconfont icon-checkbox checked-icon"
                style="color: #1449B9;"
              ></i>
              <i
                v-else
                class="iconfont icon-checkbox no-checked-icon"
                style="color: #999;"
              ></i>
            </div>
          </el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <div
              slot-scope="scope"
              style="display: flex;justify-content: center;"
            >
              <div>
                <button
                  size="mini"
                  class="table-btn"
                  @click="deleteLive(scope.row.id)"
                >
                  取消关联
                </button>
              </div>
            </div>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog
      :visible.sync="addLiveShow"
      class="dialog"
      width="500px"
      top="25vh"
    >
      <div slot="title" class="dialog-title">
        {{ (type === "add" ? "新增" : "编辑") + "绑定视频号" }}
      </div>
      <el-form
        ref="form"
        :rules="rules"
        :model="addLiveForm"
        class="live-form"
        label-width="auto"
      >
        <el-form-item label="视频号名称:" prop="name" class="form-item">
          <el-input
            placeholder="请输入视频号名称"
            class="add-renovation-input"
            v-model="addLiveForm.name"
            style="width: 254px"
          ></el-input>
        </el-form-item>
        <el-form-item label="视频号ID:" prop="channelsId" class="form-item">
          <el-input
            placeholder="请输入视频号ID"
            class="add-renovation-input"
            v-model="addLiveForm.channelsId"
            style="width: 254px"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel-btn btn" @click="addLiveShow = false"
          >取 消</el-button
        >
        <el-button class="confirm-btn btn" @click="handleLive">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 修改排序弹窗 -->
    <el-dialog title="更改排序" width="400px" :visible.sync="sortShow">
      <el-form label-width="60px" size="mini" ref="editSort" inline-message>
        <el-form-item label="排序：" prop="tableData" style="margin-top: 15px">
          <el-input v-model="currentSort" type="number" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn cancel-btn" @click="sortShow = false"
          >取 消</el-button
        >
        <el-button class="btn confirm-btn" @click="saveSort">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
export default {
  components: {
    Header
  },
  name: 'live',
  data() {
    return {
      loading: 0, // 加载中
      title: {
        // 页面标题
        firstTitile: '用户管理',
        secondTitle: '视频号管理'
      },
      liveList: [], // 轮播列表
      rules: {},
      wayMap: {
        1: '商品',
        2: '文章',
        3: '品牌'
      },
      sortShow: false,
      currentSort: 0,
      addLiveForm: {
        name: '',
        channelsId: '',
      },
      addLiveShow: false,
      liveId: null,
      type: '',
      liveType: 1
    };
  },
  mounted() {
    // 获取列表
    this.getLiveList();
  },
  computed: {},
  methods: {
    // 表格序号
    tableIndex(index) {
      return ++index;
    },
    // 获取轮播列表
    getLiveList() {
      this.loading++;
      this.httpGet(this.$root.getLiveList, {}).then(
        (res) => {
          this.loading--;
          this.liveList = res.list;
          // this.total = res.total;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    // 编辑轮播弹窗
    handleLiveModal(type, rowData) {
      this.type = type;
      if (type === 'edit') {
        this.liveId = rowData.id;
        this.addLiveForm = {
          name: rowData.name,
          channelsId: rowData.channelsId,
        };
      } else {
        this.addLiveForm = {
          name: '',
          channelsId: ''
        };
        this.$refs.form && this.$refs.form.clearValidate();
      }
      this.addLiveShow = true;
    },
    updateLiveStatus(row){
      let str = '目标视频号仅可设置一个，是否将当前视频号设为跳转目标？';
      if(row.status === 1){
        str = '是否取消当前视频号跳转目标？';
      }
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>设为跳转目标</p><p class='text' style='text-indent: 0'>${str}</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpPut(this.$root.updateLiveStatus, {
          id: row.id,
          status: row.status === 1 ? 0 : 1
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.getLiveList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    // 删除轮播图
    deleteLive(id) {
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定要取消关联吗？</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpDelete(this.$root.deleteLive, {
          id,
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.getLiveList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    // 轮播
    handleLive() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let url =
            this.type === 'add'
              ? this.$root.addLive
              : this.$root.addLive;
          let method =
            this.type === 'add'
              ? 'httpPost'
              : 'httpPost';
          let inputData =
            this.type === 'add'
              ? {
                  ...this.addLiveForm,
                }
              : {
                  ...this.addLiveForm,
                };
          this.loading++;
          // inputData.orderBy = +inputData.orderBy;
          this[method](url, inputData).then(
            (res) => {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.loading--;
              this.addLiveShow = false;
              this.getLiveList();
            },
            (res) => {
              this.loading--;
              this.$message.error(res);
            }
          );
        }
      });
    },
    changeSortModal() {
      // this.sortShow = true;
    },
    // 图片改变
    addChangeImg(e) {
      this.upPic(e, (res) => {
        this.$set(this.addLiveForm, 'pic', res);
        // 清空input value，解决重复图片不触发change
        this.$refs.inputImg.value = '';
        this.$refs.form.clearValidate(['pic']);
      });
    },
    // 上传图片
    upPic(e, fun) {
      // 上传图片
      let file = e.target.files[0];
      if (!file) {
        return;
      }
      this.request.upPic({ prefix: 'other', file: file }).then(
        (res) => {
          fun(res);
        },
        (res) => {}
      );
    },
    saveSort() {}
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.live-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 0 20px 20px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      background: white;
      box-sizing: border-box;
      padding: 24px 32px;
      border-radius: 2px;

      // 按钮
      .btn {
        // width: 100px;
        display: inline-block;
        padding: 0 30px;
        height: 32px;
        line-height: 32px;
        confirm-btn();
        font-size: 14px;
        margin-bottom: 16px;
        // margin: 16px 0;
      }

      .tip {
        margin-left: 32px;
        color: #40B98F;
      }

      // 表格按钮
      .table-btn {
        width: 65px;
        height: 24px;
        line-height: 24px;
        color: gray3;
        font-size: 12px;
        margin-right: 8px;
        cancel-btn();
      }

      .table-img {
        height: 70px;
        width: auto;
      }
    }
  }

  .dialog-content {
    flex-y();
  }

  .addImg {
    .icon {
      width: 270px;
      height: 108px;
    }
  }

  .live-form {
    margin-top: 30px;
    margin-bottom: 50px;
    padding-left: 60px;

    .sort-tip {
      word(14px, #c8c8c8);
      line-height: 20px;
    }
  }
}
</style>
